module.exports = {"542423100":"比如镇","542423101":"夏曲镇","542423200":"白嘎乡","542423201":"羊秀乡","542423202":"香曲乡","542423203":"达塘乡","542423204":"良曲乡","542423205":"茶曲乡","542423206":"扎拉乡","542423207":"恰则乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542423.json
// module id = 2553
// module chunks = 0